<div class="hb-page">
  <div class="pb-page-header">
    <app-header (changeLanguage)="changeLanguage($event)" (changeRepresentation)="changeRepresentation($event)" (logout)="logout()" />
  </div>

  <main class="hb-page-main">
    <div class="hb-container hb-container--width-sm">
      <hb-notify />
      <router-outlet />
      <hb-timeout (timeoutclick)="logout()" />
    </div>
  </main>

  <div class="hb-page-footer">
    <hb-footer [version]="environmentService.environment().version" />
  </div>
</div>
